import React from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { Button, Typography } from "@mui/material";

import successIcon from "assets/images/success-icon.png";
import failedIcon from "assets/images/failed-icon.png";
import timeLimitIcon from "assets/images/time-limit.png";
import abortIcon from "assets/images/abort-icon.png";

import {
  Card,
  Field,
  PaymentDetails,
  PaymentPage,
  StatusIcon,
  StatusText,
} from "./style";
import { homeRoute } from "Routes/constants";
import downloadFile from "utils/downloadFile";
import { getImageUrl } from "utils";

const getResponseDetails = (status) => {
  switch (status) {
    case "Success":
      return {
        iconUrl: successIcon,
        title: "Payment successful",
        message: "",
      };

    case "Failure":
      return {
        iconUrl: failedIcon,
        title: "Payment Failed",
        message:
          "We aren't able to process your payment, Please try again later.",
      };

    case "Timeout":
      return {
        iconUrl: timeLimitIcon,
        title: "Time limit exceed",
        message:
          "The time limit for this payment has been exceeded, Please try again later.",
      };

    case "Aborted":
      return {
        iconUrl: abortIcon,
        title: "Payment aborted",
        message: "Your payment has been aborted.",
      };

    default:
      return {
        isUnexpectedStatus: true,
      };
  }
};

const PaymentResponse = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const status = searchParams.get("status");
  const name = searchParams.get("name");
  const email = searchParams.get("email");
  const amount = searchParams.get("amount");
  const paymentMode = searchParams.get("paymentMode");
  const bankRef = searchParams.get("bankRef");
  const dateTime = searchParams.get("dateTime");
  const receipt = searchParams.get("receipt");

  const { isUnexpectedStatus, iconUrl, message, title } =
    getResponseDetails(status);

  const isPaymentSuccess = status === "Success";

  const handleComplete = () => {
    navigate(homeRoute, { replace: true });
  };

  const downloadReceipt = () => {
    downloadFile(getImageUrl(receipt), `${bankRef}-payment-receipt.pdf`);
  };

  if (isUnexpectedStatus) {
    return <Navigate to={homeRoute} replace />;
  }

  return (
    <PaymentPage>
      <Card>
        <p className="ms-auto mt-2 me-2 mb-0" style={{ color: "#a1a2aa" }}>
          {dateTime}
        </p>
        <StatusIcon src={iconUrl} alt="status icon" />
        <StatusText isPaymentSuccess={isPaymentSuccess}>{title}</StatusText>
        <PaymentDetails>
          <Field>
            Payment type
            <span>{paymentMode}</span>
          </Field>
          <Field>
            Name
            <span>{name}</span>
          </Field>
          <Field>
            Email
            <span>{email}</span>
          </Field>
          <Field>
            Bank reference number
            <span>{bankRef}</span>
          </Field>
          <Field className="amount-field">
            Amount
            <div>
              <span className="rupee-symbol">&#8377;</span>{" "}
              <span>{amount}</span>
            </div>
          </Field>
        </PaymentDetails>
        {isPaymentSuccess ? (
          <div>
            <Button
              variant="outlined"
              color="success"
              className="me-3"
              onClick={downloadReceipt}
            >
              PRINT RECEIPT
            </Button>
            <Button variant="outlined" color="success" onClick={handleComplete}>
              COMPLETE
            </Button>
          </div>
        ) : (
          <>
            <Typography color="error" className="mb-3">
              {message}
            </Typography>
            <Button onClick={handleComplete} variant="outlined" color="primary">
              BACK TO HOME
            </Button>
          </>
        )}
      </Card>
    </PaymentPage>
  );
};

export default PaymentResponse;
